import { render } from "./Fotos.vue?vue&type=template&id=0b5684d9&scoped=true"
import script from "./Fotos.vue?vue&type=script&lang=js"
export * from "./Fotos.vue?vue&type=script&lang=js"

import "./Fotos.vue?vue&type=style&index=0&id=0b5684d9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5684d9"]])

export default __exports__